import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Firestore, collection, addDoc, serverTimestamp } from '@angular/fire/firestore';
import { Auth } from '@angular/fire/auth';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
import { FirestoreService } from 'src/app/shared/services/firestore.service';

@Component({
  selector: 'app-refer-vendor-dialog',
  templateUrl: './refer-vendor-dialog.component.html',
  styleUrls: ['./refer-vendor-dialog.component.scss']
})
export class ReferVendorDialogComponent implements OnInit {
  referForm: FormGroup;
  isSubmitting = false;

  constructor(
    public dialogRef: MatDialogRef<ReferVendorDialogComponent>,
    private fb: FormBuilder,
    private firestore: Firestore,
    private auth: Auth,
    private ux: UxserviceService,
    private firestoreService: FirestoreService
  ) {
    this.referForm = this.fb.group({
      customerName: [{ value: '', disabled: true }],
      customerPhone: [{ value: '', disabled: true }],
      customerEmail: [{ value: '', disabled: true }],
      vendors: this.fb.array([this.createVendorGroup()])
    });
  }

  ngOnInit() {
    this.loadUserProfile();
  }

  createVendorGroup() {
    return this.fb.group({
      vendorName: ['', [Validators.required, Validators.minLength(2)]],
      vendorEmail: ['', [Validators.email]],
      vendorPhone: ['', [Validators.required, Validators.minLength(7)]],
    });
  }

  get vendors(): FormArray {
    return this.referForm.get('vendors') as FormArray;
  }

  addVendor() {
    this.vendors.push(this.createVendorGroup());
  }

  removeVendor(index: number) {
    if (this.vendors.length > 1) {
      this.vendors.removeAt(index);
    }
  }

  async loadUserProfile() {
    const user = this.auth.currentUser;
    if (user) {
      try {
        const profile: any = await this.firestoreService.getUserProfile(user.uid);
        if (profile && profile !== 'No user Details') {
          this.referForm.patchValue({
             customerName: profile.displayname || profile.firstname || user.displayName || 'Anonymous',
             customerPhone: profile.phoneNumber || user.phoneNumber || '',
             customerEmail: profile.email || user.email || ''
          });
        }
      } catch (e) {
        console.error('Error fetching user profile', e);
      }
    }
  }

  async submitReferral() {
    if (this.referForm.invalid) {
      this.referForm.markAllAsTouched();
      this.vendors.controls.forEach(control => {
        if (control instanceof FormGroup) {
          Object.keys(control.controls).forEach(key => {
            control.controls[key].markAsTouched();
          });
        }
      });
      return;
    }

    this.isSubmitting = true;
    try {
      const user = this.auth.currentUser;
      const refCol = collection(this.firestore, 'vendor-referrals');
      
      const formVal = this.referForm.getRawValue();
      const customerData = {
         referredByUid: user?.uid || null,
         referredByName: formVal.customerName,
         referredByPhone: formVal.customerPhone,
         referredByEmail: formVal.customerEmail,
      };

      const promises = formVal.vendors.map((v: any) => {
         return addDoc(refCol, {
           vendorName: v.vendorName,
           vendorEmail: v.vendorEmail,
           vendorPhone: v.vendorPhone,
           ...customerData,
           createdAt: serverTimestamp(),
           status: 'pending'
         });
      });

      await Promise.all(promises);

      this.ux.showSuccess('Thank you for referring!', 'Referrals Sent');
      this.dialogRef.close(true);
    } catch (error) {
      console.error('Error submitting referral:', error);
      this.ux.showError('Something went wrong. Please try again later.');
    } finally {
      this.isSubmitting = false;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
